import { Typography } from 'antd';
import React from 'react';
import Empty from '@/components/QuietEmpty';
import { formatCrmDate } from '@/modules/zy-crm/utils/display';
import styles from './style.module.less';

const { Paragraph } = Typography;

export type DrawerAssistSummaryItem = {
  uuid: string;
  content: string;
};

export type DrawerAssistSummary = {
  title: string;
  generatedAt?: string;
  overview: string;
  bullets: DrawerAssistSummaryItem[];
  suggestions: DrawerAssistSummaryItem[];
};

export const createDrawerAssistSummaryItems = (
  prefix: string,
  items: string[],
): DrawerAssistSummaryItem[] =>
  items.map((content, index) => ({
    uuid: `${prefix}-${index}`,
    content,
  }));

export function DrawerAssistPanel({
  summary,
  emptyText = '暂无辅助建议',
  showTitle = true,
}: {
  summary?: DrawerAssistSummary;
  emptyText?: string;
  showTitle?: boolean;
}) {
  if (!summary) {
    return (
      <div className={styles.empty}>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} />
      </div>
    );
  }

  return (
    <div className={styles.frame}>
      <div className={styles.head}>
        {showTitle ? (
          <span className={styles.title}>{summary.title}</span>
        ) : (
          <span />
        )}
        <span className={styles.stamp}>
          生成日期：{formatCrmDate(summary.generatedAt, 'date')}
        </span>
      </div>
      <Paragraph className={styles.overview}>{summary.overview}</Paragraph>

      <div className={styles.sectionTitle}>汇总</div>
      <ul className={styles.list}>
        {summary.bullets.map((item) => (
          <li key={item.uuid}>{item.content}</li>
        ))}
      </ul>

      <div className={styles.sectionTitle} style={{ marginTop: 16 }}>
        建议
      </div>
      <ol className={styles.list}>
        {summary.suggestions.map((item) => (
          <li key={item.uuid}>{item.content}</li>
        ))}
      </ol>
    </div>
  );
}
